/**
 * Composable for managing type-based color styling
 * Provides unified access to the color system across components
 */
import { colorsBg, colorsBorders, colorsText, colorsOutline, colorsButtons, colorsButtonsOutline } from '@/components/ui/colors.js'

export function useTypeStyles() {
  /**
   * Get color classes based on type and variant
   * @param {string} type - Color type (success, danger, warning, info, etc.)
   * @param {string} variant - Variant type (bg, text, border, outline, button, buttonOutline)
   * @returns {Array} Array of CSS classes
   */
  const getColorClasses = (type, variant = 'bg') => {
    const colorMaps = {
      bg: colorsBg,
      text: colorsText,
      border: colorsBorders,
      outline: colorsOutline,
      button: colorsButtons,
      buttonOutline: colorsButtonsOutline
    }

    const colorMap = colorMaps[variant]
    return colorMap?.[type] || []
  }

  /**
   * Get icon-specific color classes
   * Used by IconRounded and similar components
   * @param {string} type - Color type
   * @param {boolean} bg - Whether to use background variant or text variant
   * @returns {Array} Array of CSS classes
   */
  const getIconColorClasses = (type, bg = false) => {
    if (bg) {
      return colorsBg[type] || []
    }
    return [...(colorsText[type] || []), 'bg-theme-bg-subtle', 'dark:bg-theme-bg']
  }

  return {
    getColorClasses,
    getIconColorClasses
  }
}
